import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|string|null} action - Optional callback function, object, or 'error' type
 */
export const useAlert = (message, action = null) => {
  // Support 'error' as second parameter for compatibility
  if (action === 'error') {
    emitter.emit('newToastMessage', {
      message,
      action: null,
      // Some components may expect a type property
      type: 'error'
    });
  } else {
    emitter.emit('newToastMessage', { message, action });
  }
};
